module.exports = __webpack_public_path__ + "static/img/m_pro3.3b134d11.png";